import * as objectConstants from '../constants/objectConstants';
import * as assetConstants from '../constants/assetConstants';

//DATA SHORT HAND REFERENCES

export const BITES ={
    ref: "bites",
    key: "bi"
};

export const BITE_ID ={
    ref: "bite_id",
    key: "b"
};

export const SCREENS ={
    ref: "screens",
    key: "sr"
};

export const SUB_SCREENS ={
    ref: "sub_screens",
    key: "sbr"
};


export const SCREEN_ID ={
    ref: "screen_id",
    key: "x"
};

export const OBJECTS ={
    ref: "objects",
    key: "ob"
};

export const ASSET_ID ={
    ref: "asset_id",
    key: "a"
};

export const OPTIONS ={
    ref: "options",
    key: "op"
};

export const OPTION_ID ={
    ref: "option_id",
    key: "o"
};

export const KPIS ={
    ref: "kpis",
    key: "k"
};

export const KPI_ID ={
    ref: "kpi_id",
    key: "ki"
};

export const KPI_VALUE ={
    ref: "value",
    key: "v"
};

export const KPI_CURRENT_VALUE ={
    ref: "current",
    key: "c"
};
export const KPI_CURRENT_SCORE_RANGE ={
    ref: "currentScoreRange",
    key: "csr"
};

export const KPI_HISTORY ={
    ref: "history",
    key: "h"
};

export const STATUS = {
    ref: "status",
    key: "s"
};

export const HAS_VALUE = {
    ref: "hasValue",
    key: "y"
};

export const RESULT = {
    ref: "result",
    key: "re"
};

export const NULL = {
    ref: null,
    key: "N"
};

export const EMPTY_STRING = {
    ref: "",
    key: ""
};

export const UNDEFINED = {
    ref: undefined,
    key: "U"
};

export const ACHIEVEMENTS = {
    ref: "achievements",
    key: "achs"
};

export const BADGES = {
    ref: "badges",
    key: "bdg"
};

export const BADGE_ID = {
    ref: "badge_id",
    key: "bgi"
};


export const ACHIEVED = {
	ref: "achieved",
	key: "ach"
};

export const ACHIEVED_ON = {
    ref: "achievedOn",
    key: "ao"
};


export const ATTACHMENTS = {
    ref: "attachments",
    key: "at"
};


export const ID = {
    ref: "id",
    key: "id"
};


export const TYPE = {
    ref: "type",
    key: "t"
};

export const SUB_TYPE = {
    ref: "sub_type",
    key: "st"
};

export const ASSET_TYPE_IMAGE = {
    ref: assetConstants.ASSET_TYPE_IMAGE,
    key: "IM"
};

export const ASSET_TYPE_VIDEO = {
    ref: assetConstants.ASSET_TYPE_VIDEO,
    key: "V"
};

export const ASSET_TYPE_LINK = {
    ref: assetConstants.ASSET_TYPE_LINK,
    key: "L"
};

export const ASSET_TYPE_DOCUMENT = {
    ref: assetConstants.ASSET_TYPE_DOCUMENT,
    key: "D"
};


export const ASSET_SUB_TYPE_MP4 = {
    ref: assetConstants.ASSET_SUB_TYPE_MP4,
    key: assetConstants.ASSET_SUB_TYPE_MP4
};

export const ASSET_SUB_TYPE_YOUTUBE = {
    ref: assetConstants.ASSET_SUB_TYPE_YOUTUBE,
    key: "YT"
};

export const ASSET_SUB_TYPE_VIMEO = {
    ref: assetConstants.ASSET_SUB_TYPE_VIMEO,
    key: "VIM"
};

export const REF_STATUS_NOT_REQUIRED = {
    ref: objectConstants.STATUS_NOT_REQUIRED,
    key: objectConstants.STATUS_NOT_REQUIRED
};


export const REF_STATUS_NOT_STARTED = {
    ref: objectConstants.STATUS_NOT_STARTED,
    key: objectConstants.STATUS_NOT_STARTED
};

export const REF_STATUS_IN_PROGRESS = {
    ref: objectConstants.STATUS_IN_PROGRESS,
    key: objectConstants.STATUS_IN_PROGRESS
};

export const REF_STATUS_COMPLETE = {
    ref: objectConstants.STATUS_COMPLETE,
    key: objectConstants.STATUS_COMPLETE
};

export const REF_STATUS_ATTEMPTED = {
    ref: objectConstants.STATUS_ATTEMPTED,
    key: objectConstants.STATUS_ATTEMPTED
};

export const REF_STATUS_SAVED = {
    ref: objectConstants.STATUS_SAVED,
    key: objectConstants.STATUS_SAVED
};

export const REF_STATUS_PASSED = {
    ref: objectConstants.STATUS_PASSED,
    key: objectConstants.STATUS_PASSED
};

export const REF_STATUS_FAILED = {
    ref: objectConstants.STATUS_FAILED,
    key: objectConstants.STATUS_FAILED
};


export const REF_RESULT_BEST = {
    ref: objectConstants.RESULT_BEST,
    key: objectConstants.RESULT_BEST
};

export const REF_RESULT_OK = {
    ref: objectConstants.RESULT_OK,
    key: objectConstants.RESULT_OK
};

export const REF_RESULT_POOR = {
    ref: objectConstants.RESULT_POOR,
    key: objectConstants.RESULT_POOR
};

export const RESOURCES ={
    ref: "resources",
    key: "rc"
};

export const PERCENTAGE_COMPLETE = {
    ref: "percentageComplete",
    key: "pc"
};

export const ACTIVE = {
    ref: "active",
    key: "ac"
};

export const REQUIRED = {
    ref: "required",
    key: "r"
};

export const REF_TRUE = {
    ref: true,
    key: 1
};

export const REF_FALSE = {
    ref: false,
    key: 0
};

export const COMPLETE_TARGET_SCREENS = {
  ref: "complete_target_screens",
  key: "cts"
};

export const TERMINATED = {
    ref: "terminated",
    key: "tm"
};

export const SHORT_RESPONSE_QUESTIONS ={
    ref: "short_response_questions",
    key: "srq"
};

export const RESPONSE = {
    ref: "response",
    key: "rp"
};


export const STATUS_INDICATOR_CLASS = {
    ref: "statusIndicatorClass",
    key:  "z"
};

export const SHORT_HAND_KEYS = [
    BITES,
    BITE_ID,
    SCREENS,
    SUB_SCREENS,
    SCREEN_ID,
    OBJECTS,
    ASSET_ID,
    OPTIONS,
    OPTION_ID,
    KPIS,
    KPI_ID,
    KPI_VALUE,
    KPI_CURRENT_VALUE,
    KPI_CURRENT_SCORE_RANGE,
    KPI_HISTORY,
    STATUS,
    HAS_VALUE,
    RESULT,
    NULL,
    EMPTY_STRING,
    UNDEFINED,
    REF_STATUS_NOT_REQUIRED,
    REF_STATUS_NOT_STARTED,
    REF_STATUS_IN_PROGRESS,
    REF_STATUS_COMPLETE,
    REF_STATUS_ATTEMPTED,
    REF_STATUS_SAVED,
    REF_STATUS_PASSED,
    REF_STATUS_FAILED,
    REF_RESULT_BEST,
    REF_RESULT_OK,
    REF_RESULT_POOR,
    RESOURCES,
    PERCENTAGE_COMPLETE,
    ACTIVE,
    REQUIRED,
	ACHIEVEMENTS,
    BADGES,
    BADGE_ID,
	ACHIEVED,
    ACHIEVED_ON,
    ATTACHMENTS,
    ID,
    TYPE,
    SUB_TYPE,
    ASSET_TYPE_IMAGE,
    ASSET_TYPE_DOCUMENT,
    ASSET_TYPE_LINK,
    ASSET_TYPE_VIDEO,
    ASSET_SUB_TYPE_MP4,
    ASSET_SUB_TYPE_VIMEO,
    ASSET_SUB_TYPE_YOUTUBE,
    REF_TRUE,
    REF_FALSE,
    COMPLETE_TARGET_SCREENS,
    TERMINATED,
    SHORT_RESPONSE_QUESTIONS,
    RESPONSE,
    STATUS_INDICATOR_CLASS
];



/** WEBPACK FOOTER **
 ** ./src/models/shortHandModels.js
 **/